<div class="ml-assist-container">
  <span class="subtitle-03">ML Assist</span>
  <h3-toggle-button-group
    size="xs"
    [buttons]="rangeButtons"
    [ngModel]="selectedRange$ | async"
    (ngModelChange)="setMlAssistRange($event)"
  ></h3-toggle-button-group>
</div>
